var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAgenda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.68713 5.82039C7.17824 5.82039 7.55386 5.44555 7.55386 4.95389V3.22086C7.55386 2.72919 7.17824 2.35352 6.68713 2.35352C6.19594 2.35352 5.82031 2.72919 5.82031 3.22086V4.95389C5.82031 5.44555 6.19594 5.82039 6.68713 5.82039Z",
    fill: "#E9E9F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08707 17.9547H8.70987V20.266H4.08707V17.9547ZM4.08707 14.4878H8.70987V16.7991H4.08707V14.4878ZM4.08707 11.021H8.70987V13.3322H4.08707V11.021ZM14.4884 11.021V13.3322H9.86557V11.021H14.4884ZM20.2669 11.021V13.3322H15.6441V11.021H20.2669ZM20.2669 16.7991H15.6441V14.4878H20.2669V16.7991ZM20.2669 20.266H15.6441V17.9547H20.2669V20.266ZM9.86557 16.7991V14.4878H14.4884V16.7991H9.86557ZM9.86557 20.266V17.9547H14.4884V20.266H9.86557ZM2.35352 21.999H22.0004V9.28711H2.35352V21.999Z",
    fill: "#E9E9F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6665 5.82039C18.1577 5.82039 18.5334 5.44555 18.5334 4.95389V3.22086C18.5334 2.72919 18.1577 2.35352 17.6665 2.35352C17.1754 2.35352 16.7998 2.72919 16.7998 3.22086V4.95389C16.7998 5.44555 17.1754 5.82039 17.6665 5.82039Z",
    fill: "#E9E9F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.689 4.08691V4.95343C19.689 6.08048 18.7934 6.97555 17.6665 6.97555C16.5397 6.97555 15.6441 6.08048 15.6441 4.95343V4.08691H8.70987V4.95343C8.70987 6.08048 7.81422 6.97555 6.68744 6.97555C5.56057 6.97555 4.66492 6.08048 4.66492 4.95343V4.08691H2.35352V8.13118H22.0004V4.08691H19.689Z",
    fill: "#E9E9F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAgenda);
export default __webpack_public_path__ + "static/media/icon-agenda.0db24c3e78f36a3874a66f97d549d015.svg";
export { ForwardRef as ReactComponent };